module.exports = __webpack_public_path__ + "img/Wassermassen.fd41d9f6.jpg";